module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('mu-content-block', {
    staticClass: "food-search-dialog",
    staticStyle: {
      "padding-bottom": "0",
      "margin-bottom": "8px"
    },
    style: ({
      height: (_vm.isSearching === true) ? '100%' : 'auto'
    })
  }, [_c('mu-paper', {
    staticClass: "search-area"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "grow": "45",
      "shrink": "45"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "icon": "search",
      "hintText": "Search a food name",
      "underlineShow": false,
      "hintTextClass": "hidden",
      "fullWidth": ""
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "shrink": "5",
      "grow": "5",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "close"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isSearching) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isListening) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('div', {
    staticClass: "load-wrapp"
  }, [_c('div', {
    staticClass: "load-3 bottom"
  }, [_c('div', {
    staticClass: "line loaderRed"
  }), _vm._v(" "), _c('div', {
    staticClass: "line loaderGreen"
  }), _vm._v(" "), _c('div', {
    staticClass: "line loaderBlue"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n        Go ahead and say something...\n      ")]), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "Stop"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.stopVoiceRecognition()
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isListening) ? _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('mu-list-item', {
      key: 'suggestion-' + index,
      attrs: {
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleSelection(suggestion)
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "slot": "left",
        "value": "search"
      },
      slot: "left"
    }), _vm._v(" "), _vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.highlight(suggestion)))
      },
      slot: "title"
    }), 0, 'suggestion-' + index)], 1)
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f719f2d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FoodDiary/Search/Search.vue
// module id = 3688
// module chunks = 1